(() => {
  'use strict';
  const entityDecoder = document.createElement('textarea');
  const decodeText = value => value.replace(/&(?:#[0-9]+|#x[0-9a-f]+|[a-z][a-z0-9]*);/gi, entity => {
    entityDecoder.innerHTML = entity;
    return entityDecoder.value;
  });
  const decodeJSONText = value => {
    if (typeof value === 'string') return decodeText(value);
    if (Array.isArray(value)) return value.map(decodeJSONText);
    if (value && typeof value === 'object') return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, decodeJSONText(item)]));
    return value;
  };
  const readJSON = id => {
    try { return decodeJSONText(JSON.parse(document.getElementById(id)?.textContent || 'null')); }
    catch { return null; }
  };
  const ui = readJSON('ax-ui-strings') || {};
  const parsedMachines = readJSON('ax-machines-data');
  const machines = Array.isArray(parsedMachines) ? parsedMachines : [];
  const text = (key, values = {}) => Object.entries(values).reduce((value, [name, replacement]) => value.replaceAll(`__${name}__`, String(replacement)), String(ui[key] || ''));
  const select = (selector, scope = document) => scope.querySelector(selector);
  const selectAll = (selector, scope = document) => [...scope.querySelectorAll(selector)];
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const dialogTriggers = new WeakMap();
  const inquiry = document.getElementById('inquiry-dialog');
  const form = document.getElementById('AxInquiryForm');
  const currentProduct = select('[data-current-product]');
  const field = id => document.getElementById(`quote-${id}`);
  const draftKey = 'aonxin-inquiry-pending';
  const draftFields = ['machine', 'country', 'email', 'whatsapp', 'company', 'quantity', 'city', 'tractor', 'details', 'product', 'configuration', 'variant', 'context', 'page'];
  let method = 'email';

  const openDialog = (dialog, trigger = document.activeElement) => {
    if (!dialog || dialog.open) return;
    closeMenu();
    closeLanguage();
    dialogTriggers.set(dialog, trigger);
    dialog.showModal();
    document.body.classList.add('modal-open');
  };
  const closeDialog = dialog => { if (dialog?.open) dialog.close(); };
  selectAll('dialog').forEach(dialog => {
    dialog.addEventListener('close', () => {
      if (!select('dialog[open]')) document.body.classList.remove('modal-open');
      const trigger = dialogTriggers.get(dialog);
      if (trigger?.isConnected && !trigger.closest('[hidden]')) trigger.focus({ preventScroll: true });
    });
    dialog.addEventListener('click', event => {
      if (event.target !== dialog) return;
      const box = dialog.getBoundingClientRect();
      if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeDialog(dialog);
    });
  });

  function closeLanguage(restoreFocus = false) {
    const panel = document.getElementById('language-panel');
    const toggle = select('.language-toggle');
    if (!panel || !toggle) return;
    const wasOpen = !panel.hidden;
    panel.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
    if (wasOpen && restoreFocus) toggle.focus();
  }
  function closeMenu(restoreFocus = false) {
    const nav = document.getElementById('mobile-nav');
    const button = select('.mobile-menu-button');
    if (!nav || !button) return;
    const wasOpen = !nav.hidden;
    nav.hidden = true;
    nav.classList.remove('open');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', text('openMenu'));
    if (wasOpen && restoreFocus) button.focus();
  }

  let slide = 0;
  let paused = reducedMotion.matches;
  let hovered = false;
  let focused = false;
  const stage = select('.hero-stage');
  function updatePause() {
    const button = select('[data-pause]');
    if (!button) return;
    button.setAttribute('aria-label', text(paused ? 'playCarousel' : 'pauseCarousel'));
    button.setAttribute('aria-pressed', String(paused));
    const path = select('path', button);
    if (path) path.setAttribute('d', paused ? 'm8 5 11 7-11 7V5Z' : 'M9 5v14M15 5v14');
  }
  function updateSlide(index) {
    if (!stage || !machines.length) return;
    slide = (index + machines.length) % machines.length;
    const machine = machines[slide];
    const image = select('.hero-image', stage);
    if (image && machine.image) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = machine.image;
      image.alt = machine.name || '';
    }
    const title = document.getElementById('hero-machine-title');
    const description = document.getElementById('hero-machine-description');
    const category = document.getElementById('stage-category');
    const number = document.getElementById('slide-number');
    const link = document.getElementById('hero-machine-link');
    if (title) title.textContent = machine.name || '';
    if (description) description.textContent = machine.description || '';
    if (category) category.textContent = machine.category === 'road' ? text('roadCategory') : machine.category === 'land' ? text('landCategory') : machine.category || '';
    if (number) number.textContent = String(slide + 1).padStart(2, '0');
    if (link && machine.url) {
      link.href = machine.url;
      link.setAttribute('aria-label', text('viewMachine', { name: machine.name || '' }));
    }
    selectAll('[data-slide]', stage).forEach(button => button.setAttribute('aria-current', String(Number(button.dataset.slide) === slide)));
  }
  if (stage && machines.length > 1) {
    stage.addEventListener('pointerenter', () => { hovered = true; });
    stage.addEventListener('pointerleave', () => { hovered = false; });
    stage.addEventListener('focusin', () => { focused = true; });
    stage.addEventListener('focusout', event => { focused = stage.contains(event.relatedTarget); });
    window.setInterval(() => {
      if (!paused && !hovered && !focused && !document.hidden && !select('dialog[open]')) updateSlide(slide + 1);
    }, 6000);
    updatePause();
  }
  reducedMotion.addEventListener('change', event => { paused = event.matches; updatePause(); });

  function filterMachines(category) {
    const cards = selectAll('.product-grid .product-card[data-product-category]');
    if (!cards.length) return;
    const allowed = ['all', ...new Set(cards.map(card => card.dataset.productCategory))];
    const value = allowed.includes(category) ? category : 'all';
    let count = 0;
    cards.forEach(card => {
      card.hidden = value !== 'all' && card.dataset.productCategory !== value;
      if (!card.hidden) count++;
    });
    selectAll('[data-filter]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.filter === value)));
    const result = select('.result-count');
    if (result) result.textContent = text('machineCount', { count });
  }

  function stopMedia(pane) {
    selectAll('video', pane).forEach(video => video.pause());
    selectAll('iframe', pane).forEach(frame => {
      const source = frame.getAttribute('src');
      if (source) frame.setAttribute('src', source);
    });
  }
  function changeGallery(button) {
    const imagePane = select('[data-gallery-image-pane]');
    const image = select('.gallery-main');
    const panes = selectAll('[data-gallery-video-pane]');
    const kind = button.dataset.mediaType || 'image';
    const isImage = kind === 'image';
    const gallery = button.closest('[data-product-gallery]');
    if (gallery) gallery.dataset.activeMediaId = button.dataset.mediaId || '';
    panes.forEach(pane => {
      if (!pane.hidden) stopMedia(pane);
      pane.hidden = isImage || pane.dataset.mediaId !== button.dataset.mediaId;
    });
    if (imagePane) imagePane.hidden = !isImage;
    selectAll('[data-zoom]').forEach(control => { control.hidden = !isImage; });
    if (isImage && image && button.dataset.src) {
      image.removeAttribute('srcset');
      image.removeAttribute('sizes');
      image.src = button.dataset.src;
      image.alt = button.dataset.alt || '';
    }
    selectAll('[data-gallery]').forEach(control => control.setAttribute('aria-pressed', String(control === button)));
  }

  function setHiddenField(id, value) {
    const input = field(id);
    if (!input) return;
    input.value = value || '';
    input.disabled = !value;
  }
  function syncProductContext() {
    if (!form) return;
    const chosen = field('machine')?.selectedOptions[0];
    const handle = chosen?.dataset.handle || '';
    const isCurrent = Boolean(currentProduct && handle === currentProduct.dataset.currentProduct);
    setHiddenField('product', handle && handle !== 'support' ? chosen.value : '');
    if (isCurrent) {
      const configuration = document.getElementById('configuration');
      const variant = document.getElementById('product-variant') || select('[name="id"]', currentProduct);
      const selectedVariant = variant?.selectedOptions?.[0];
      const variantId = variant?.value || currentProduct.dataset.variantId || '';
      const variantTitle = selectedVariant?.dataset.title || variant?.dataset.title || currentProduct.dataset.variantTitle || '';
      setHiddenField('configuration', configuration?.selectedOptions?.[0]?.textContent.trim() || configuration?.value || '');
      setHiddenField('variant', variantId ? [variantTitle, variantId].filter(Boolean).join(' · ') : '');
    } else {
      setHiddenField('configuration', '');
      setHiddenField('variant', '');
    }
  }
  function openQuote(button) {
    if (!inquiry || !form) return;
    const requested = button.dataset.quote || currentProduct?.dataset.currentProduct || '';
    const option = [...field('machine').options].find(item => item.dataset.handle === requested);
    if (option) field('machine').value = option.value;
    setHiddenField('context', button.dataset.context || '');
    syncProductContext();
    updateWhatsApp();
    openDialog(inquiry, button);
    const response = select('[data-contact-errors], [data-contact-success]', form);
    (response || field('machine')).focus({ preventScroll: true });
  }
  function switchMethod(next) {
    if (!form || !['email', 'whatsapp'].includes(next)) return;
    method = next;
    const whatsapp = method === 'whatsapp';
    selectAll('[data-method]', form).forEach(button => button.setAttribute('aria-pressed', String(button.dataset.method === method)));
    select('[data-email-field]', form).hidden = whatsapp;
    select('[data-whatsapp-field]', form).hidden = !whatsapp;
    field('email').disabled = whatsapp;
    field('email').required = !whatsapp;
    field('whatsapp').disabled = !whatsapp;
    field('whatsapp').required = whatsapp;
    field('submit').hidden = whatsapp;
    field('whatsapp-link').hidden = !whatsapp;
    field('method-note').textContent = text(whatsapp ? 'whatsappNote' : 'emailNote');
    updateWhatsApp();
  }
  function updateWhatsApp() {
    if (!form) return;
    const rows = [text('whatsappHeading')];
    const values = [
      ['machineLabel', 'machine'], ['countryLabel', 'country'], ['whatsappLabel', 'whatsapp'],
      ['companyLabel', 'company'], ['quantityLabel', 'quantity'], ['cityLabel', 'city'],
      ['tractorLabel', 'tractor'], ['detailsLabel', 'details'], ['configurationLabel', 'configuration'],
      ['variantLabel', 'variant'], ['contextLabel', 'context'], ['pageLabel', 'page']
    ];
    values.forEach(([label, id]) => {
      const value = field(id)?.value.trim();
      if (value) rows.push(`${text(label)}: ${value}`);
    });
    field('whatsapp-link').href = `https://wa.me/8613153729963?text=${encodeURIComponent(rows.join('\n'))}`;
  }
  function saveDraft() {
    const values = Object.fromEntries(draftFields.map(id => [id, field(id)?.value || '']));
    try { sessionStorage.setItem(draftKey, JSON.stringify({ time: Date.now(), values })); } catch { }
  }
  function restoreDraft() {
    try {
      const draft = JSON.parse(sessionStorage.getItem(draftKey) || 'null');
      if (!draft?.values || Date.now() - draft.time > 1800000) { sessionStorage.removeItem(draftKey); return; }
      draftFields.forEach(id => {
        const input = field(id);
        const value = draft.values[id];
        if (!input || typeof value !== 'string') return;
        input.value = value;
        if (['product', 'configuration', 'variant', 'context'].includes(id)) input.disabled = !value;
      });
      const optional = select('.form-optional', form);
      if (optional && ['company', 'quantity', 'city', 'tractor', 'details'].some(id => field(id)?.value)) optional.open = true;
    } catch { }
  }

  if (form) {
    form.addEventListener('input', updateWhatsApp);
    field('machine').addEventListener('change', () => { syncProductContext(); updateWhatsApp(); });
    form.addEventListener('invalid', event => {
      const details = event.target.closest('details');
      if (details) details.open = true;
    }, true);
    form.addEventListener('submit', event => {
      if (method === 'whatsapp') {
        event.preventDefault();
        if (form.reportValidity()) { updateWhatsApp(); field('whatsapp-link').click(); }
        return;
      }
      saveDraft();
    });
    field('whatsapp-link').addEventListener('click', event => {
      if (!form.reportValidity()) { event.preventDefault(); return; }
      updateWhatsApp();
    });
    const success = select('[data-contact-success]', form);
    const errors = select('[data-contact-errors]', form);
    if (success) {
      try { sessionStorage.removeItem(draftKey); } catch { }
      openDialog(inquiry);
      success.focus({ preventScroll: true });
    } else if (errors) {
      restoreDraft();
      openDialog(inquiry);
      errors.focus({ preventScroll: true });
    } else if (location.hash === '#inquiry-dialog') {
      openDialog(inquiry);
    }
    updateWhatsApp();
  }

  const variantSelect = document.getElementById('product-variant');
  if (variantSelect) variantSelect.addEventListener('change', () => {
    const selected = variantSelect.selectedOptions?.[0];
    if (currentProduct) {
      currentProduct.dataset.variantId = variantSelect.value;
      currentProduct.dataset.variantTitle = selected?.dataset.title || variantSelect.dataset.title || '';
    }
    const mediaId = selected?.dataset.mediaId || variantSelect.dataset.mediaId;
    const thumbnail = selectAll('[data-gallery]').find(item => mediaId && item.dataset.mediaId === mediaId);
    if (thumbnail) changeGallery(thumbnail);
    const url = new URL(location.href);
    url.searchParams.set('variant', variantSelect.value);
    history.replaceState(history.state, '', url);
    syncProductContext();
    updateWhatsApp();
  });
  document.getElementById('configuration')?.addEventListener('change', () => { syncProductContext(); updateWhatsApp(); });

  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const target = event.target.closest('button,a');
    if (!event.target.closest('.language')) closeLanguage();
    if (!target) return;
    if (target.hasAttribute('data-quote') && inquiry) { event.preventDefault(); openQuote(target); return; }
    if (target.hasAttribute('data-close')) { closeDialog(target.closest('dialog')); return; }
    if (target.matches('.language-toggle')) {
      const panel = document.getElementById('language-panel');
      if (panel) { panel.hidden = !panel.hidden; target.setAttribute('aria-expanded', String(!panel.hidden)); }
      return;
    }
    if (target.matches('.mobile-menu-button')) {
      const nav = document.getElementById('mobile-nav');
      if (nav) {
        nav.hidden = !nav.hidden;
        nav.classList.toggle('open', !nav.hidden);
        target.setAttribute('aria-expanded', String(!nav.hidden));
        target.setAttribute('aria-label', text(nav.hidden ? 'openMenu' : 'closeMenu'));
      }
      return;
    }
    if (target.hasAttribute('data-machines') && document.getElementById('machines')) {
      event.preventDefault();
      filterMachines(target.dataset.category || 'all');
      closeMenu();
      document.getElementById('machines').scrollIntoView({ behavior: reducedMotion.matches ? 'instant' : 'smooth' });
      return;
    }
    if (target.closest('.mobile-nav')) closeMenu();
    if (target.hasAttribute('data-filter')) { filterMachines(target.dataset.filter); return; }
    if (target.hasAttribute('data-slide')) { updateSlide(Number(target.dataset.slide)); return; }
    if (target.hasAttribute('data-prev')) { updateSlide(slide - 1); return; }
    if (target.hasAttribute('data-next')) { updateSlide(slide + 1); return; }
    if (target.hasAttribute('data-pause')) { paused = !paused; updatePause(); return; }
    if (target.hasAttribute('data-gallery')) { changeGallery(target); return; }
    if (target.hasAttribute('data-zoom')) {
      const source = select('.gallery-main');
      const dialog = document.getElementById('image-dialog');
      const image = dialog && select('img', dialog);
      if (source && image) {
        image.src = source.currentSrc || source.src;
        image.alt = source.alt;
        select('p', dialog).textContent = source.alt;
        openDialog(dialog, target);
      }
      return;
    }
    if (target.hasAttribute('data-method')) switchMethod(target.dataset.method);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape' || select('dialog[open]')) return;
    const language = document.getElementById('language-panel');
    if (language && !language.hidden) closeLanguage(true);
    else closeMenu(true);
  });
  select('.language')?.addEventListener('focusout', event => {
    if (event.relatedTarget && !event.currentTarget.contains(event.relatedTarget)) closeLanguage();
  });
  window.matchMedia('(min-width: 981px)').addEventListener('change', event => { if (event.matches) closeMenu(); });
  const requestedCategory = new URLSearchParams(location.search).get('category');
  if (requestedCategory) filterMachines(requestedCategory);
})();
